import { render, staticRenderFns } from "./HostingInstancesCard.vue?vue&type=template&id=d0071290&scoped=true"
import script from "./HostingInstancesCard.vue?vue&type=script&lang=js"
export * from "./HostingInstancesCard.vue?vue&type=script&lang=js"
import style0 from "./HostingInstancesCard.vue?vue&type=style&index=0&id=d0071290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0071290",
  null
  
)

export default component.exports